import * as THREE from 'three'
import Experience from "../Experience"

export default class Alosa {
    constructor() {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.resources = this.experience.resources
        this.time = this.experience.time
        this.debug = this.experience.debug

        // Debug
        // if (this.debug.active) {
        //     this.debugFolder = this.debug.ui.addFolder('fish')
        // }

        // Setup
        this.resource = this.resources.items.alosaModel

        this.setModel()
        // this.setTextures()
        this.setAnimation()
        // this.setMaterial()

    }

    // Check if hotspot is clicked
    addEventListeners() {
        // window.addEventListener('click', (event) => document.querySelectorAll('.point-fish')[0].switchAnimation(), false);
        // document.querySelectorAll('.point-fish')[0].addEventListener('click', this.switchAnimation)
        // document.querySelectorAll('.point-fish')[0].parentElement.querySelector('.close').addEventListener('click', this.switchAnimation)
    }

    setModel() {

        this.model = this.resource.scene
        // this.model.position.set(1.7, -.35, 4.15)
        this.model.position.set(3.9, -.35, 3)
        this.model.scale.set(0.01, 0.01, 0.01)
        this.model.rotation.set(0, Math.PI * .9, 0)
        this.scene.add(this.model)

        this.originalMesh = this.model.children[0]; // Assuming it's a Mesh
        this.geometry = this.originalMesh.geometry;
        this.material = this.originalMesh.material;

        // Finally add to the scene
        this.scene.add(this.model);

        // for (let i = 0; i < 10; i++) {
        //     this.copy = this.model.clone();
        //     this.copy.position.set(Math.random() * -.75, .5, Math.random() * -4.5);
        //     this.copy.children[0].scale.set(Math.random() * 0.1, Math.random() * 0.1, Math.random() * 0.1)
        //     this.scene.add(this.copy);
        // }

        this.model.traverse((child) => {
            if (child instanceof THREE.Mesh) {
                child.material.dispose()
                child.material = new THREE.MeshStandardMaterial({ map: child.material.map, metalness: 0.3, roughness: 1 })
                child.receiveShadow = true
                child.castShadow = true // It's under the boat so no shadow needed
            }
        })
    }

    setMaterial() {
        let m = this.model.children[0].material

        if (m) {
            m.dispose()
        }

        // m.visible = false
        m = new THREE.MeshStandardMaterial({
            color: 0xffffff,
            envMap: null,
            map: null,
        })
        m.needsUpdate = true;
    }

    setAnimation() {
        this.animation = {}
        this.animation.mixer = new THREE.AnimationMixer(this.model)
        this.animation.mixer.clipAction(this.resource.animations[0]).play()

        // this.animation.actions.current.time = 50
    }


    update() {

        this.animation.mixer.update(this.time.delta / 1000) // Divide by 1000 because it's in milliseconds
    }
}